// Shipping methods, prices, and listed transit ranges reviewed against the store's General delivery profile on 2026-09-27.
// Do not infer a delivery date for methods whose transit range is not listed.
export const RATE_SNAPSHOT_DATE = '2026-09-27';
export const DELIVERY_ZONES = [
  {
    name: 'USA', countries: ['US'],
    methods: [
      {name: 'USPS Standard Shipping', kind: 'standard', price: 0, currency: 'USD', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 12, currency: 'USD', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 22, currency: 'USD', transit: [3, 5]},
    ],
  },
  {
    name: 'UK', countries: ['GB'],
    methods: [
      {name: 'Evri Standard Shipping', kind: 'standard', price: 0, currency: 'GBP', transit: [3, 7]},
      {name: 'Royal Mail Standard Shipping', kind: 'standard', price: 0, currency: 'GBP', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 7, currency: 'GBP', transit: [3, 5]},
    ],
  },
  {
    name: 'Germany', countries: ['DE'],
    methods: [
      {name: 'GLS Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Deutsche Post Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'France', countries: ['FR'],
    methods: [
      {name: 'GLS Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'La Poste Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Italy', countries: ['IT'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Poste Italiane Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Spain', countries: ['ES'],
    methods: [
      {name: 'GLS Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Correos Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Netherlands', countries: ['NL'],
    methods: [
      {name: 'GLS Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'PostNL Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Belgium', countries: ['BE'],
    methods: [
      {name: 'DHL Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'bpost Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Austria', countries: ['AT'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Austrian Post Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Portugal', countries: ['PT'],
    methods: [
      {name: 'MRW Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'CTT Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Czechia', countries: ['CZ'],
    methods: [
      {name: 'Packeta Standard Shipping', kind: 'standard', price: 0, currency: 'CZK', transit: [3, 7]},
      {name: 'Česká pošta Postal Shipping', kind: 'standard', price: 0, currency: 'CZK', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 225, currency: 'CZK', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 300, currency: 'CZK', transit: [3, 5]},
    ],
  },
  {
    name: 'Bulgaria', countries: ['BG'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Bulgarian Posts Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Croatia', countries: ['HR'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Hrvatska pošta Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Estonia', countries: ['EE'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Omniva Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Hungary', countries: ['HU'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'HUF', transit: [3, 7]},
      {name: 'Magyar Posta Postal Shipping', kind: 'standard', price: 0, currency: 'HUF', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 3400, currency: 'HUF', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 4500, currency: 'HUF', transit: [3, 5]},
    ],
  },
  {
    name: 'Latvia', countries: ['LV'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Latvijas Pasts Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Lithuania', countries: ['LT'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Lietuvos paštas Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Luxembourg', countries: ['LU'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'POST Luxembourg Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Malta', countries: ['MT'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'MaltaPost Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Romania', countries: ['RO'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'RON', transit: [3, 7]},
      {name: 'Poșta Română Postal Shipping', kind: 'standard', price: 0, currency: 'RON', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 48, currency: 'RON', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 64, currency: 'RON', transit: [3, 5]},
    ],
  },
  {
    name: 'Slovakia', countries: ['SK'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Slovenská pošta Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Slovenia', countries: ['SI'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Pošta Slovenije Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Monaco', countries: ['MC'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'La Poste Monaco Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Cyprus', countries: ['CY'],
    methods: [
      {name: 'Cyprus Post Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Greece', countries: ['GR'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'ELTA Hellenic Post Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Denmark', countries: ['DK'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'DKK', transit: [3, 7]},
      {name: 'PostNord Postal Shipping', kind: 'standard', price: 0, currency: 'DKK', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 67, currency: 'DKK', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 90, currency: 'DKK', transit: [3, 5]},
    ],
  },
  {
    name: 'Finland', countries: ['FI'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'Posti Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Ireland', countries: ['IE'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [3, 7]},
      {name: 'An Post Postal Shipping', kind: 'standard', price: 0, currency: 'EUR', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 9, currency: 'EUR', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 12, currency: 'EUR', transit: [3, 5]},
    ],
  },
  {
    name: 'Poland', countries: ['PL'],
    methods: [
      {name: 'DHL Standard Shipping', kind: 'standard', price: 0, currency: 'PLN', transit: [3, 7]},
      {name: 'Poczta Polska Postal Shipping', kind: 'standard', price: 0, currency: 'PLN', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 39, currency: 'PLN', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 53, currency: 'PLN', transit: [3, 5]},
    ],
  },
  {
    name: 'Sweden', countries: ['SE'],
    methods: [
      {name: 'Widect Standard Shipping', kind: 'standard', price: 0, currency: 'SEK', transit: [3, 7]},
      {name: 'PostNord Postal Shipping', kind: 'standard', price: 0, currency: 'SEK', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 101, currency: 'SEK', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 135, currency: 'SEK', transit: [3, 5]},
    ],
  },
  {
    name: 'Bosnia & Herzegovina', countries: ['BA'],
    methods: [
      {name: 'BH Pošta Postal Shipping', kind: 'standard', price: 29, currency: 'BAM', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 57, currency: 'BAM', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 63, currency: 'BAM', transit: [3, 5]},
    ],
  },
  {
    name: 'Iceland', countries: ['IS'],
    methods: [
      {name: 'Pósturinn Postal Shipping', kind: 'standard', price: 2055, currency: 'ISK', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 3973, currency: 'ISK', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 4384, currency: 'ISK', transit: [3, 5]},
    ],
  },
  {
    name: 'Faroe Islands', countries: ['FO'],
    methods: [
      {name: 'Posta Postal Shipping', kind: 'standard', price: 112, currency: 'DKK', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 217, currency: 'DKK', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 239, currency: 'DKK', transit: [3, 5]},
    ],
  },
  {
    name: 'Serbia', countries: ['RS'],
    methods: [
      {name: 'Pošta Srbije Postal Shipping', kind: 'standard', price: 1761, currency: 'RSD', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 3404, currency: 'RSD', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 3756, currency: 'RSD', transit: [3, 5]},
    ],
  },
  {
    name: 'North Macedonia', countries: ['MK'],
    methods: [
      {name: 'Post of North Macedonia Postal Shipping', kind: 'standard', price: 925, currency: 'MKD', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 1788, currency: 'MKD', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 1973, currency: 'MKD', transit: [3, 5]},
    ],
  },
  {
    name: 'Georgia', countries: ['GE'],
    methods: [
      {name: 'Georgian Post Postal Shipping', kind: 'standard', price: 44, currency: 'GEL', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 84, currency: 'GEL', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 93, currency: 'GEL', transit: [3, 5]},
    ],
  },
  {
    name: 'Moldova', countries: ['MD'],
    methods: [
      {name: 'Poșta Moldovei Postal Shipping', kind: 'standard', price: 300, currency: 'MDL', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 581, currency: 'MDL', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 641, currency: 'MDL', transit: [3, 5]},
    ],
  },
  {
    name: 'Europe 2', countries: ['BY'],
    methods: [{name: 'FedEx Express Shipping', kind: 'express', price: 29, currency: 'EUR', transit: [3, 5]}],
  },
  {
    name: 'Norway', countries: ['NO'],
    methods: [
      {name: 'Posten Postal Shipping', kind: 'standard', price: 96, currency: 'NOK', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 161, currency: 'NOK', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 343, currency: 'NOK', transit: [3, 5]},
    ],
  },
  {
    name: 'Switzerland', countries: ['CH'],
    methods: [
      {name: 'Swiss Post Postal Shipping', kind: 'standard', price: 8, currency: 'CHF', transit: [5, 10]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 14, currency: 'CHF', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 30, currency: 'CHF', transit: [3, 5]},
    ],
  },
  {
    name: 'Canada', countries: ['CA'],
    methods: [
      {name: 'FedEx Express Shipping', kind: 'express', price: 34, currency: 'CAD', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 64, currency: 'CAD', transit: [3, 5]},
    ],
  },
  {
    name: 'Australia', countries: ['AU'],
    methods: [
      {name: 'Australia Post Standard Shipping', kind: 'standard', price: 14, currency: 'AUD', transit: [9, 15]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 43, currency: 'AUD', transit: [3, 5]},
    ],
  },
  {
    name: 'New Zealand', countries: ['NZ'],
    methods: [
      {name: 'NZ Post Standard Shipping', kind: 'standard', price: 36, currency: 'NZD', transit: [9, 15]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 71, currency: 'NZD', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 107, currency: 'NZD', transit: [3, 5]},
    ],
  },
  {
    name: 'Japan', countries: ['JP'],
    methods: [
      {name: 'Japan Post Standard Shipping', kind: 'standard', price: 1500, currency: 'JPY', transit: [9, 15]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 4700, currency: 'JPY', transit: [3, 5]},
    ],
  },
  {
    name: 'Singapore', countries: ['SG'],
    methods: [
      {name: 'SingPost Standard Shipping', kind: 'standard', price: 12, currency: 'SGD', transit: [9, 15]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 38, currency: 'SGD', transit: [3, 5]},
      {name: 'UPS Express Shipping', kind: 'express', price: 58, currency: 'SGD', transit: [3, 5]},
    ],
  },
  {
    name: 'Hong Kong', countries: ['HK'],
    methods: [
      {name: 'Hongkong Post Standard Shipping', kind: 'standard', price: 120, currency: 'HKD', transit: [9, 15]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 200, currency: 'HKD', transit: [3, 5]},
    ],
  },
  {
    name: 'Malaysia', countries: ['MY'],
    methods: [
      {name: 'Pos Malaysia Standard Shipping', kind: 'standard', price: 62, currency: 'MYR', transit: [9, 15]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 104, currency: 'MYR', transit: [3, 5]},
    ],
  },
  {
    name: 'Taiwan', countries: ['TW'],
    methods: [
      {name: 'Chunghwa Post Standard Shipping', kind: 'standard', price: 490, currency: 'TWD', transit: [9, 15]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 810, currency: 'TWD', transit: [3, 5]},
    ],
  },
  {
    name: 'South Korea', countries: ['KR'],
    methods: [
      {name: 'Korea Post Standard Shipping', kind: 'standard', price: 20400, currency: 'KRW', transit: [9, 15]},
      {name: 'FedEx Express Shipping', kind: 'express', price: 34100, currency: 'KRW', transit: [3, 5]},
    ],
  },
];

export function zoneForCountry(countryCode) {
  return DELIVERY_ZONES.find(zone => zone.countries.includes(countryCode)) ?? null;
}

export function carrierForMethod(methodName) {
  if (methodName.startsWith('Pos Malaysia ')) return 'pos-malaysia';
  if (methodName.startsWith('Chunghwa Post ')) return 'chunghwa-post';
  if (methodName.startsWith('Korea Post ')) return 'korea-post';
  if (methodName.startsWith('Hongkong Post ')) return 'hongkong-post';
  if (methodName.startsWith('Swiss Post ')) return 'swiss-post';
  if (methodName.startsWith('Posten ')) return 'posten';
  if (methodName.startsWith('Pošta Slovenije ')) return 'posta-slovenije';
  if (methodName.startsWith('Slovenská pošta ')) return 'slovenska-posta';
  if (methodName.startsWith('Poșta Română ')) return 'posta-romana';
  if (methodName.startsWith('MaltaPost ')) return 'maltapost';
  if (methodName.startsWith('POST Luxembourg ')) return 'post-luxembourg';
  if (methodName.startsWith('Magyar Posta ')) return 'magyar-posta';
  if (methodName.startsWith('Latvijas Pasts ')) return 'latvijas-pasts';
  if (methodName.startsWith('Lietuvos paštas ')) return 'lietuvos-pastas';
  if (methodName.startsWith('Omniva ')) return 'omniva';
  if (methodName.startsWith('Hrvatska pošta ')) return 'hrvatska-posta';
  if (methodName.startsWith('Bulgarian Posts ')) return 'bulgarian-posts';
  if (methodName.startsWith('Packeta ')) return 'packeta';
  if (methodName.startsWith('Česká pošta ')) return 'ceska-posta';
  if (methodName.startsWith('MRW ')) return 'mrw';
  if (methodName.startsWith('CTT ')) return 'ctt';
  if (methodName.startsWith('Austrian Post ')) return 'austrian-post';
  if (methodName.startsWith('DHL ')) return 'dhl';
  if (methodName.startsWith('bpost ')) return 'bpost';
  if (methodName.startsWith('PostNL ')) return 'postnl';
  if (methodName.startsWith('Correos ')) return 'correos';
  if (methodName.startsWith('Widect ')) return 'widect';
  if (methodName.startsWith('Poste Italiane ')) return 'poste-italiane';
  if (methodName.startsWith('Poczta Polska ')) return 'poczta-polska';
  if (methodName.startsWith('An Post ')) return 'an-post';
  if (methodName.startsWith('Posti ')) return 'posti';
  if (methodName.startsWith('Posta Postal ')) return 'posta-faroe';
  if (methodName.startsWith('Pošta Srbije ')) return 'posta-srbije';
  if (methodName.startsWith('Post of North Macedonia ')) return 'north-macedonia-post';
  if (methodName.startsWith('Georgian Post ')) return 'georgian-post';
  if (methodName.startsWith('Poșta Moldovei ')) return 'posta-moldovei';
  if (methodName.startsWith('Pósturinn ')) return 'posturinn';
  if (methodName.startsWith('BH Pošta ')) return 'bh-posta';
  if (methodName.startsWith('PostNord ')) return 'postnord';
  if (methodName.startsWith('ELTA Hellenic Post ')) return 'elta';
  if (methodName.startsWith('Cyprus Post ')) return 'cyprus-post';
  if (methodName.startsWith('La Poste Monaco ')) return 'la-poste-monaco';
  if (methodName.startsWith('La Poste ')) return 'la-poste';
  if (methodName.startsWith('GLS ')) return 'gls';
  if (methodName.startsWith('Deutsche Post ')) return 'deutsche-post';
  if (methodName.startsWith('Royal Mail ')) return 'royal-mail';
  return /^(USPS|FedEx|UPS|Evri)\b/.exec(methodName)?.[1].toLowerCase() ?? null;
}

// These are the merchant-confirmed last-mile partners for the generic Standard
// Shipping rate. The checkout method remains "Standard Shipping" because the
// origin carrier can vary before the parcel reaches the destination country.
export const STANDARD_LAST_MILE = {
  JP: 'Japan Post',
  AU: 'Australia Post',
  NZ: 'NZ Post',
  SG: 'SingPost',
};

// Monaco is treated as France for customs and VAT purposes.
const EU_VAT_TERRITORIES = new Set([
  'MC',
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
  'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
]);

export function taxNotice(countryCode, countryName) {
  if (countryCode === 'HK') {
    return 'Hong Kong does not levy VAT or general import tariffs on ordinary goods. The recipient is responsible for customs clearance, requested documents and any applicable import charges or carrier service fees.';
  }
  if (['MY', 'TW', 'KR'].includes(countryCode)) {
    let notice = `Import duties, taxes and carrier clearance fees may be charged by customs or the carrier in ${countryName}. The recipient is responsible for customs clearance, requested documentation and any applicable import charges.`;
    if (countryCode === 'TW') notice += ' For express shipments, complete EZ WAY real-name authorization or the customs authorization required by the carrier.';
    if (countryCode === 'KR') notice += ' A valid Personal Customs Clearance Code (PCCC) is required for personal e-commerce imports. Provide it directly to the carrier when requested.';
    return notice;
  }
  if (countryCode === 'US') {
    return 'All U.S. orders ship with import fees included. No additional taxes or charges at delivery.';
  }
  if (countryCode === 'CA') {
    return 'All Canadian orders ship with import fees included. No additional taxes or charges at delivery.';
  }
  if (countryCode === 'GB') {
    return 'UK VAT is collected at checkout on eligible orders with a goods value up to £135 before VAT. Above this threshold, import charges may apply.';
  }
  if (EU_VAT_TERRITORIES.has(countryCode)) {
    return `For deliveries to ${countryName}, prices marked “Taxes included” already include VAT. For orders over €150 before VAT, import VAT and carrier fees may be due at delivery.`;
  }
  return `For ${countryName}, import duties, taxes, or carrier fees may be due at delivery unless checkout clearly states they are included.`;
}

export function addBusinessDays(startDate, days) {
  if (!Number.isInteger(days) || days < 0) throw new RangeError('Business days must be a non-negative integer');
  const date = new Date(startDate.getTime());
  while (days > 0) {
    date.setUTCDate(date.getUTCDate() + 1);
    const weekday = date.getUTCDay();
    if (weekday !== 0 && weekday !== 6) days -= 1;
  }
  return date;
}

// The workshop continues production on Turkish public holidays, but cannot hand
// parcels to a carrier then. Treat half-day holidays as closed for dispatch:
// the estimate has no pickup time or carrier-specific half-day cutoff.
// Source (2026–2028): https://vakithesaplama.diyanet.gov.tr/icerik.php?icerik=158
// and the linked 2027/2028 official holiday lists. Refresh before 2029.
export const ORIGIN_DISPATCH_HOLIDAYS_THROUGH = 2028;
const ORIGIN_DISPATCH_HOLIDAYS = new Set([
  '2026-01-01', '2026-03-19', '2026-03-20', '2026-03-21', '2026-03-22',
  '2026-04-23', '2026-05-01', '2026-05-19', '2026-05-26', '2026-05-27',
  '2026-05-28', '2026-05-29', '2026-05-30', '2026-07-15', '2026-08-30',
  '2026-10-28', '2026-10-29',
  '2027-01-01', '2027-03-08', '2027-03-09', '2027-03-10', '2027-03-11',
  '2027-04-23', '2027-05-01', '2027-05-15', '2027-05-16', '2027-05-17',
  '2027-05-18', '2027-05-19', '2027-07-15', '2027-08-30', '2027-10-28',
  '2027-10-29',
  '2028-01-01', '2028-02-25', '2028-02-26', '2028-02-27', '2028-02-28',
  '2028-04-23', '2028-05-01', '2028-05-04', '2028-05-05', '2028-05-06',
  '2028-05-07', '2028-05-08', '2028-05-19', '2028-07-15', '2028-08-30',
  '2028-10-28', '2028-10-29',
]);

export function nextOriginDispatchDay(readyDate) {
  const date = new Date(readyDate.getTime());
  while (date.getUTCFullYear() <= ORIGIN_DISPATCH_HOLIDAYS_THROUGH) {
    const weekday = date.getUTCDay();
    if (weekday !== 0 && weekday !== 6
        && !ORIGIN_DISPATCH_HOLIDAYS.has(date.toISOString().slice(0, 10))) return date;
    date.setUTCDate(date.getUTCDate() + 1);
  }
  return null; // Do not display unverified dates after the holiday calendar expires.
}

export function todayAtFulfillmentOrigin(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = type => Number(parts.find(item => item.type === type)?.value);
  return new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
}

export function deliveryWindow(method, processingMin, processingMax, today = todayAtFulfillmentOrigin()) {
  if (!method?.transit || method.transit.length !== 2) return null;
  const min = Number(processingMin);
  const max = Number(processingMax);
  if (!Number.isInteger(min) || !Number.isInteger(max) || min < 0 || max < min) return null;
  const firstDispatch = nextOriginDispatchDay(addBusinessDays(today, min));
  const lastDispatch = nextOriginDispatchDay(addBusinessDays(today, max));
  if (!firstDispatch || !lastDispatch) return null;
  return {
    earliest: addBusinessDays(firstDispatch, method.transit[0]),
    latest: addBusinessDays(lastDispatch, method.transit[1]),
  };
}

export function formatDateWindow(window) {
  if (!window) return '';
  const formatter = new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', timeZone: 'UTC'});
  const start = formatter.format(window.earliest);
  const end = formatter.format(window.latest);
  if (window.earliest.getUTCFullYear() === window.latest.getUTCFullYear()
      && window.earliest.getUTCMonth() === window.latest.getUTCMonth()) {
    return `${start}–${window.latest.getUTCDate()}`;
  }
  return `${start}–${end}`;
}

function money(amount, currency) {
  const digits = new Intl.NumberFormat('en-US', {style: 'currency', currency})
    .resolvedOptions().maximumFractionDigits;
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency,
    minimumFractionDigits: Number.isInteger(amount) ? 0 : digits,
    maximumFractionDigits: digits,
  }).format(amount);
}

export function priceLabel(method, selectedCurrency, conversion = null) {
  if (method.priceRule) {
    if (selectedCurrency !== method.currency) return {main: 'At checkout', detail: ''};
    return {
      main: 'FREE',
      detail: `on orders ${money(method.priceRule.freeFrom, method.currency)}+; ${money(method.priceRule.below, method.currency)} below`,
    };
  }
  if (method.price === 0) return {main: 'FREE', detail: ''};
  if (method.localPreview?.currency === selectedCurrency) {
    return {main: `≈${money(method.localPreview.amount, selectedCurrency)}`, detail: ''};
  }
  if (selectedCurrency !== method.currency) {
    if (conversion?.baseCurrency === method.currency
        && conversion.activeCurrency === selectedCurrency
        && Number.isFinite(conversion.rate) && conversion.rate > 0) {
      return {main: `≈${money(method.price * conversion.rate, selectedCurrency)}`, detail: 'Approx. local price'};
    }
    return {main: `${money(method.price, method.currency)} ${method.currency}`, detail: ''};
  }
  return {main: money(method.price, method.currency), detail: ''};
}

function element(tag, className, content = '') {
  const node = document.createElement(tag);
  node.className = className;
  node.textContent = content;
  return node;
}

if (typeof customElements !== 'undefined' && !customElements.get('delivery-estimate')) {
  customElements.define('delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-delivery-open]');
      this.closeButton = this.querySelector('[data-delivery-close]');
      const zone = zoneForCountry(this.dataset.countryCode);
      if (!this.dialog || !this.opener || !this.closeButton || !zone?.methods.length) return;
      this.zone = zone;
      this.processingMin = Number(this.dataset.processingMin);
      this.processingMax = Number(this.dataset.processingMax);
      if (!Number.isInteger(this.processingMin) || !Number.isInteger(this.processingMax)
          || this.processingMin < 0 || this.processingMax < this.processingMin) return;
      this.lifecycle = new AbortController();
      const options = {signal: this.lifecycle.signal};
      this.opener.addEventListener('click', () => this.open(), options);
      this.closest('product-info')?.addEventListener('click', event => {
        const trigger = event.target.closest?.('[data-delivery-note-open]');
        if (trigger) this.open(trigger);
      }, options);
      this.closeButton.addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('close', () => this.afterClose(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.close();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') this.render();
      }, options);
      this.render();
      this.hidden = false;
    }

    render() {
      const countryName = this.dataset.countryName || this.dataset.countryCode;
      const primary = this.zone.methods.find(method => method.kind === 'standard') ?? this.zone.methods[0];
      const primaryWindow = deliveryWindow(primary, this.processingMin, this.processingMax);
      this.querySelector('[data-delivery-eyebrow]').textContent = primaryWindow ? 'Delivery estimate' : 'Shipping options';
      this.querySelector('[data-delivery-headline]').textContent = primaryWindow
        ? formatDateWindow(primaryWindow) : `Shipping to ${countryName}`;
      const subtitle = this.querySelector('[data-delivery-subtitle]');
      if (primaryWindow && primary.kind === 'standard' && primary.price === 0) {
        subtitle.replaceChildren(`${countryName} · `, element('strong', '', 'FREE'), ' Standard Shipping');
      } else {
        subtitle.textContent = primaryWindow
          ? `${countryName} · ${primary.kind === 'standard' ? 'Standard' : 'Express'} shipping`
          : 'View available methods and prices';
      }
      this.querySelector('[data-delivery-title]').textContent = `Delivery to ${countryName}`;
      const taxCopy = this.querySelector('[data-delivery-tax]');
      const taxText = taxNotice(this.dataset.countryCode, countryName);
      const emphasis = 'U.S. orders';
      const index = taxText.indexOf(emphasis);
      if (this.dataset.countryCode === 'US' && index >= 0) {
        taxCopy.replaceChildren(taxText.slice(0, index), element('strong', '', emphasis),
          taxText.slice(index + emphasis.length));
      } else {
        taxCopy.textContent = taxText;
      }

      if (EU_VAT_TERRITORIES.has(this.dataset.countryCode)) {
        taxCopy.append(document.createElement('br'), document.createElement('br'),
          'We cover the EU’s €3 customs duty — you won’t pay this charge.');
      }

      const methods = this.querySelector('[data-delivery-methods]');
      methods.replaceChildren();
      for (const method of this.zone.methods) {
        const row = element('div', 'delivery-estimate__method');
        const details = element('div', 'delivery-estimate__method-details');
        const lastMile = method.kind === 'standard' && STANDARD_LAST_MILE[this.dataset.countryCode];
        const carrier = carrierForMethod(method.name) ?? (lastMile ? lastMile.toLowerCase().replaceAll(' ', '-') : null);
        const logoUrl = carrier && this.getAttribute(`data-carrier-${carrier}-logo`);
        if (logoUrl) {
          const logo = document.createElement('img');
          logo.className = 'delivery-estimate__carrier-logo';
          logo.src = logoUrl;
          if (carrier === 'posta-romana') logo.style.filter = 'brightness(0)';
          logo.alt = lastMile ? `Local delivery by ${lastMile}` : '';
          logo.width = 66;
          logo.height = 40;
          if (lastMile) logo.classList.add('delivery-estimate__carrier-logo--last-mile');
          else logo.setAttribute('aria-hidden', 'true');
          logo.addEventListener('error', () => logo.remove(), {once: true});
          details.append(logo);
        }
        const copy = element('div', 'delivery-estimate__method-copy');
        const displayName = this.dataset.countryCode === 'AU' && lastMile && !method.name.startsWith(lastMile)
          ? `${lastMile} ${method.name}` : method.name;
        copy.append(element('strong', 'delivery-estimate__method-name', displayName));
        const deliveryDates = deliveryWindow(method, this.processingMin, this.processingMax);
        const timing = deliveryDates
          ? `${formatDateWindow(deliveryDates)} · ${method.transit[0]}–${method.transit[1]} business days in transit`
          : 'Timing varies by destination';
        copy.append(element('span', 'delivery-estimate__method-time', timing));
        const shopifyCurrency = window.Shopify?.currency;
        const conversion = {
          baseCurrency: this.dataset.baseCurrency,
          activeCurrency: shopifyCurrency?.active,
          rate: Number(shopifyCurrency?.rate),
        };
        const price = priceLabel(method, this.dataset.currencyCode, conversion);
        const priceElement = element('span', 'delivery-estimate__method-price', price.main);
        if (price.detail) priceElement.append(element('small', '', price.detail));
        details.append(copy);
        row.append(details, priceElement);
        methods.append(row);
      }
      this.querySelector('[data-delivery-note-caveat]').textContent = primaryWindow
        ? 'Delivery dates may vary due to holidays or customs.'
        : 'Transit time varies by destination.';
    }

    open(trigger = this.opener) {
      if (this.dialog.open || document.querySelector('dialog[open]')) return;
      this.returnFocusTarget = trigger;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.scrollLocked = true;
      this.querySelector('.delivery-estimate__sheet').scrollTop = 0;
      this.dialog.showModal();
      this.closeButton.focus({preventScroll: true});
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      this.afterClose();
    }

    afterClose() {
      if (!this.scrollLocked || this.dialog.open) return;
      document.body.style.overflow = this.previousOverflow;
      this.scrollLocked = false;
      if (this.isConnected) (this.returnFocusTarget?.isConnected ? this.returnFocusTarget : this.opener).focus({preventScroll: true});
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = null;
      if (this.dialog?.open) this.dialog.close();
      this.afterClose();
    }
  });
}
